import { AxiosResponse } from 'axios'
import { IRequisiteHistoryErrors } from '../../../common/api/error.types'
import { IRequisiteHistoryResponse } from './logs.types'
import {
  getErrorResponse,
  getErrorStatus,
  getErrorText,
  getGeneralError,
} from '../../../common/api/errors'

export const isApiErrorTicketToken = (
  error: unknown
): error is AxiosResponse<IRequisiteHistoryErrors<IRequisiteHistoryResponse>> => {
  return typeof getErrorResponse<IRequisiteHistoryResponse>(error)?.paymentTicketToken === 'string'
}

/** Text of a refused client-flags export: the client id field by its Russian name, otherwise the common rules. */
export const externalUserFlagsExportErrorText = (error: unknown): string => {
  const fallback = 'Не удалось экспортировать данные'
  const userIdError = getErrorResponse<{ userId?: unknown }>(error)?.userId
  const status = getErrorStatus(error)
  if (
    getGeneralError(error) === undefined &&
    typeof userIdError === 'string' &&
    !(status !== undefined && status >= 500)
  ) {
    return `Ошибка в поле ID клиента: ${userIdError}`
  }

  return getErrorText(error, fallback)
}
